import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(public toastController: ToastController) { }

  async showToast(status: 'danger' | 'warning' | 'success', tMessage: string) {
    const toast = await this.toastController.create({
      message: tMessage,
      duration: 3000,
      color: status
    });

    return await toast.present();
  }

  async addToast() {
    let toast = await this.toastController.create({
      message: 'Wurde erfolgreich gespeichert',
      duration: 3000,
      position: 'middle',
      color: 'success',
    });
    toast.present();
  }

  async addToastNot() {
    let toast = await this.toastController.create({
      message: 'Wurde NICHT erfolgreich gespeichert',
      duration: 3000,
      position: 'middle',
      color: 'danger',
    });
    toast.present();
  }

  async deleteToast() {
    let toast = await this.toastController.create({
      message: 'Wurde erfolgreich gelöscht',
      duration: 3000,
      position: 'middle',
      color: 'success',
    });
    toast.present();
  }

  async deleteToastNot() {
    let toast = await this.toastController.create({
      message: 'Wurde NICHT erfolgreich gelöscht',
      duration: 3000,
      position: 'middle',
      color: 'danger',
    });
    toast.present();
  }

  async CurrentEmail() {
    let toast = await this.toastController.create({
      message: ' Du bist mit diesem User angemeldet. Kann aktuell nicht gelöscht werden',
      duration: 3000,
      position: 'middle',
      color: 'danger',
    });
    toast.present();
  }
}
